// src/firebase.ts
// Firebase is used ONLY for Hosting and Cloud Functions.
// Authentication and data storage are handled by Supabase.
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCVoMbsdSQfT2ZH6Kwn6Bi8JdA1XkPhkc",
  authDomain: "gen-lang-client-0852028495.firebaseapp.com",
  projectId: "gen-lang-client-0852028495",
  storageBucket: "gen-lang-client-0852028495.appspot.com",
  messagingSenderId: "886347754681",
  appId: "1:886347754681:web:1affaac962d8fd17027f68",
};

const app = initializeApp(firebaseConfig);

export default app;
